// B2 첨부 화면(사진 모드, 단일 화면 — 스텝퍼 없음).
// 썸네일(≤3) · 메모 · 선택 카드 2종(AI / 바로 신청) · 하단 CTA 하나.
// OCR 인식 중 → 진행 줄, 인식 실패 → 선택 카드 대신 앰버 블록 + '사진만으로 신청' CTA.
import React from 'react';
import { T, R, FONT } from '../../../theme';
import { question, Field, NoteBox, AmberBox, CtaBar, textarea, errSt, linkBtn, btnNavy, btnDisabled } from './bits';

var thumbs = { display: 'flex', flexWrap: 'wrap', gap: 10, direction: 'ltr' };   // 선택 순서가 의미 — RTL 에서도 미러 금지
var thumb = { position: 'relative', width: 92, height: 92, borderRadius: R.md, overflow: 'clip',
  border: '1px solid ' + T.bd, background: T.head, flex: 'none' };
var img = { width: '100%', height: '100%', objectFit: 'cover', display: 'block' };
var noPreview = { width: '100%', height: '100%', display: 'grid', placeItems: 'center', fontSize: FONT.label, color: T.faint, padding: 4, textAlign: 'center', wordBreak: 'break-all' };
var del = { position: 'absolute', insetInlineEnd: 4, top: 4, width: 20, height: 20, borderRadius: R.pill,
  border: 0, background: T.ink, color: T.card, fontSize: 11, lineHeight: 1, cursor: 'pointer', fontFamily: 'inherit', padding: 0 };
var addTile = { width: 92, height: 92, borderRadius: R.md, flex: 'none', display: 'flex', flexDirection: 'column',
  alignItems: 'center', justifyContent: 'center', gap: 5, border: '1px dashed ' + T.line, background: T.card,
  color: T.muted, fontSize: FONT.label, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' };
var ocrLine = { display: 'flex', alignItems: 'center', gap: 8, padding: '10px 12px', borderRadius: R.md,
  background: T.accentTint, border: '1px solid ' + T.accentBd, color: T.accentPress, fontSize: 12, fontWeight: 700 };
var choiceCard = { display: 'flex', flexDirection: 'column', gap: 4, padding: '12px 14px', borderRadius: R.card,
  border: '1px solid ' + T.bd, background: T.card, cursor: 'pointer', fontFamily: 'inherit', textAlign: 'start', width: '100%' };
var choiceOn = { border: '1px solid ' + T.accentBd, background: T.accentTint };
var chh = { display: 'flex', alignItems: 'center', gap: 8 };
var cht = { fontSize: 13, fontWeight: 800, color: T.ink, letterSpacing: '-.2px', flex: 1, minWidth: 0 };
var mark = { width: 18, height: 18, borderRadius: R.pill, flex: 'none', display: 'grid', placeItems: 'center',
  fontSize: 10, fontWeight: 800 };
var chd = { fontSize: 11.5, color: T.muted, lineHeight: 1.6 };

function ChoiceCard(props) {
  return (<button type="button" data-choice={props.id} aria-pressed={props.on}
    style={props.on ? Object.assign({}, choiceCard, choiceOn) : choiceCard} onClick={props.onClick}>
    <span style={chh}>
      <b style={cht}>{props.title}</b>
      <span style={Object.assign({}, mark, props.on
        ? { background: T.accent, color: T.card, border: '1px solid ' + T.accent }
        : { background: T.card, color: T.card, border: '1px solid ' + T.line })}>✓</span>
    </span>
    <span style={chd}>{props.desc1}</span>
    <span style={chd}>{props.desc2}</span>
  </button>);
}

function StepPhotos(props) {
  var t = props.t;
  var photos = props.photos;
  var failed = props.ocr === 'failed';
  var loading = props.ocr === 'loading';
  var ctaLabel = loading ? t('simpleB4OcrLoading') : failed ? t('simpleB4SubmitPhotosOnly') : t('simpleB4ChoiceSubmit');
  var busy = loading || props.submitting;

  return (<React.Fragment>
    <div style={question}>{t('simpleB4PhotoTitle')}</div>

    <div style={thumbs}>
      {photos.map(function (p, i) {
        return (<span key={p.key} style={thumb}>
          {p.url ? <img src={p.url} alt="" style={img} /> : <span style={noPreview}>{p.name}</span>}
          <button type="button" style={del} aria-label={t('evalActionDelete')} data-remove={i}
            onClick={function () { props.onRemove(i); }}>✕</button>
        </span>);
      })}
      {photos.length < 3 ? (<button type="button" style={addTile} data-testid="photo-add" onClick={props.onAdd}>
        <span aria-hidden="true" style={{ fontSize: 16, lineHeight: 1 }}>+</span>
        <span>{t('simpleB4Add')}</span>
      </button>) : null}
    </div>
    {props.error ? <div style={errSt} role="alert">{props.error}</div> : null}

    {loading ? <div style={ocrLine} role="status">{t('simpleB4OcrLoading')}</div> : null}

    {failed ? (<AmberBox role="alert" title={t('simpleB4OcrFailedTitle')} sub={t('simpleB4OcrFailedSub')}>
      <button type="button" style={linkBtn} onClick={props.onManualEntry}>{t('simpleB4ManualEntry')}</button>
      <button type="button" style={Object.assign({}, linkBtn, { color: T.muted })} onClick={props.onRetry}>{t('simpleOcrRetry')}</button>
    </AmberBox>) : null}

    <Field label={t('simpleMemoLabel')} htmlFor="req-memo">
      <textarea id="req-memo" style={textarea} rows={2} value={props.memo}
        placeholder={t('simpleMemoHint')} onChange={function (e) { props.onMemo(e.target.value); }} />
    </Field>
    <NoteBox><div>{t('simpleMemoLangNote')}</div></NoteBox>

    {failed ? null : (<React.Fragment>
      <ChoiceCard id="ai" on={props.choice === 'ai'} title={t('simpleB4ChoiceAiTitle')}
        desc1={photos.length === 1 ? t('simpleB4ChoiceAiDesc1Single') : t('simpleB4ChoiceAiDesc1')}
        desc2={t('simpleB4ChoiceAiDesc2')} onClick={function () { props.onChoice('ai'); }} />
      <ChoiceCard id="direct" on={props.choice === 'direct'} title={t('simpleB4ChoiceDirectTitle')}
        desc1={t('simpleB4ChoiceDirectDesc1')} desc2={t('simpleB4ChoiceDirectDesc2')}
        onClick={function () { props.onChoice('direct'); }} />
    </React.Fragment>)}

    <NoteBox><div>{t('simpleB4PhotoNote')}</div></NoteBox>

    <CtaBar isMobile={props.isMobile}>
      <button type="button" data-testid="photo-cta" disabled={busy}
        style={busy ? Object.assign({}, btnNavy, btnDisabled, { flex: 1 }) : Object.assign({}, btnNavy, { flex: 1 })}
        onClick={props.onSubmit}>{ctaLabel}</button>
    </CtaBar>
  </React.Fragment>);
}

export default StepPhotos;
